/**
 * antd-mobile 组件繁体文案
 */
export default {
  locale: 'pt',
  Pagination: {
    prevText: 'shangyiye',
    nextText: 'xiayiye',
  },
  DatePicker: {
    okText: '確認',
    dismissText: '取消',
    extra: '請選擇',
    DatePickerLocale: {
      year: '年',
      month: '月',
      day: '日',
      hour: '時',
      minute: '分',
      am: '上午',
      pm: '下午',
    },
  },
  DatePickerView: {
    year: '年',
    month: '月',
    day: '日',
    hour: '時',
    minute: '分',
    am: '上午',
    pm: '下午',
  },
  InputItem: {
    confirmLabel: '確定',
    backspaceLabel: '退格',
    cancelKeyboardLabel: '收起鍵盤',
  },
  Picker: {
    okText: '確定',
    dismissText: '取消',
    extra: '請選擇',
  },
  SearchBar: {
    cancelText: '取消',
  },
  Menu: {
    okText: '確定',
    cancelText: '取消',
  },
  PullToRefresh: {
    activateText: '鬆開立即刷新',
    deactivateText: '下拉可以刷新',
    finishText: '完成刷新',
  },
  Calendar: {
    title: '日期選擇',
    today: '今天',
    month: '月',
    year: '年',
    am: '上午',
    pm: '下午',
    dateTimeFormat: 'yyyy年MM月dd日 星期w hh:mm',
    dateFormat: 'yyyy年MM月dd日 星期w',
    noChoose: '未選擇',
    week: ['日', '一', '二', '三', '四', '五', '六'],
    clear: '清除',
    selectTime: '選擇時間',
    selectStartTime: '選擇開始時間',
    selectEndTime: '選擇結束時間',
    start: '開始',
    end: '結束',
    begin: '起',
    over: '止',
    begin_over: '起/止',
    confirm: '確認',
    monthTitle: 'yyyy年MM月',
    loadPrevMonth: '加載上一個月',
    yesterday: '昨天',
    lastWeek: '近一週',
    lastMonth: '近一個月',
  },
};
